module.exports = __webpack_public_path__ + "img/ic_renzhengziliaoshenhe.cc6ca4b1.svg";